<template>
    <div class="spvMain">
        <custom-menu></custom-menu>
        <div class="row w-100 ml-0 mr-0 mb-10 summaryFundCardLayout">
            <div class="col-12 d-flex justify-content-center align-items-center">
                <div class="col-5 d-flex flex-column justify-content-center align-items-center" style="border-right: 2px solid #c3c3c3; padding: 30px 50px 30px 0" >
                    <div class="spv-size"><span>SPV Size</span> : <span>${{spvfundSize}}</span></div>
                    <div class="spv-totals d-flex justify-content-center col-12">
                        <div><span>Investor Totals</span> : <span>${{investorTotals}}</span> </div>
                        <div><span>Manager Totals</span> : <span>{{managerTotals}}</span></div>
                    </div>
                </div>
                <div class="col-5 d-flex flex-column justify-content-center align-items-center stats" style="padding: 30px 0 30px 50px" >
                    <div class="details"><span>MOIC</span> : <span>{{moic ? moic : "-"}}</span> </div>
                    <div class="details"><span>Fees</span> : <span>{{fees}}</span></div>
                    <div class="details"><span>Carry</span> : <span>{{carry}}%</span></div>
                </div>
            </div>
        </div>
        <div class="row w-100 ml-0 mr-0 mb-10" >
            <!-- <div class="col-12"> -->
                <div class="col-6">
                    <custom-chart :data="customChartData" :total="spvfundSize" ></custom-chart>
                </div>
                <div class="col-6" style="margin-top: 10px">
                    <chartjs-polar-card v-if="showChart"
                        :chart-data="chartData"
                        :chart-options="chartOptions"
                    ></chartjs-polar-card>
                </div>
            <!-- </div> -->
        </div>
        <div class="row w-100 ml-0 mr-0 mt-10 d-flex flex-column">
            <p class="titleText">Syndicate Details</p>
            <div class="col-12 d-flex justify-content-end" >
                <button type="button" @click="value.isShow = true" class="btn buttonOutlined">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Add
                </button>
            </div>
            <div id="theMainTableSyndicateDetails">
                <div
                    class="tabulator lp-tabulator-cls"
                    ref="syndicateDetailsRefTable"
                    style="width: 100%; height: 100%"
                ></div>
            </div>
        </div>
        <div class="row w-100 ml-0 mr-0 mt-10 d-flex flex-column">
            <p class="titleText">Manager Details</p>
            <div id="theMainTableManagerDetails">
                <div
                    class="tabulator capitalCall-tabulator-cls"
                    ref="managerDetailsRefTable"
                    style="width: 100%; height: 100%"
                ></div>
            </div>
        </div>
        <div class="row w-100 ml-0 mr-0 mt-10 d-flex flex-column">
            <p class="titleText">Fund Details</p>
            <div id="theMainTableFundDetails">
                <div
                    class="tabulator capitalCall-tabulator-cls"
                    ref="fundDetailsRefTable"
                    style="width: 100%; height: 100%"
                ></div>
            </div>
        </div>
        <dialog-add-syndicate-details :value="value" @refresh="getsyndicateData"></dialog-add-syndicate-details>
        <el-dialog
        center
        title="Really Delete?"
        :closeOnClickModal="false"
        :closeOnPressEscape="false"
        width="750px"
        style="margin: 0 auto"
        :visible.sync="confirmMdlShow"
        class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
      >
        <div class="card-body">
          <div class="inputs row">
            <p style="width: 100%; text-align: center">
              Are you sure you want to delete this item? This can't be undone.
            </p>
          </div>
          <div class="actionbuttons">
            <button
              @click.prevent="
                confirmMdlShow = !confirmMdlShow;
                deleteSyndicateDetailId = '';
                isSaving = false;
              "
              class="todo-form-cancel-button btn-outline-secondary"
            >
              Cancel
            </button>
            <button
              class="todo-form-submit-button btn btn-primary"
              style="height: 35px"
              :disabled="isSaving"
              @click="deleteMethod"
            >
              Yes
              <b-spinner v-if="isSaving" small label="Spinning"></b-spinner>
            </button>
          </div>
        </div>
      </el-dialog>
    </div>
</template>
<script>
import Tabulator from "tabulator-tables";
import { mapGetters } from "vuex";
import api from "../../../axios_api";
import {
  formatCurrency,
  formatNumber,
  precisionNumberForamtter,
} from "../../../util";
import DialogAddSyndicateDetails from '../Dialogs/DialogAddSyndicateDetails.vue';
import CustomMenu from "../Components/CustomMenu.vue";
import PolarAreaChart from '../../../components/Cards/Chartjs/ChartjsPolarCard.vue';
import CustomChart from '../../../components/Cards/CustomChart.vue';
import { Dialog } from "element-ui";

export default {
    name: "spv-allocations",
    components:{
        [Dialog.name]: Dialog,
        DialogAddSyndicateDetails,
        CustomChart,
        [CustomMenu.name]: CustomMenu,
        [PolarAreaChart.name]: PolarAreaChart,
        [CustomChart.name]: CustomChart
    },
    data(){
        return{
            managerDetailsData: [],
            managerDetailsTabulator: null,
            syndicateDetailsData: [],
            syndicateDetailsTabulator: null,
            investorTotals: 0,
            managerTotals: 0,
            carry: 0,
            fees: 0,
            spvfundSize: 0,
            value: {
                isShow: false
            },
            fundDetailsData: [],
            fundDetailsTabulator: null,
            showChart: false,
            polarChartData: [],
            customChartData: [],
            confirmMdlShow: false,
            isSaving: false,
            deleteSyndicateDetailId: ""
        }
    },
    computed: {
        ...mapGetters("workspace", ["currentWorkspace"]),
        ...mapGetters("investment", ["investments"]),
        ...mapGetters("user", ["user"]),
        moic(){
            if(this.investments.length > 0){
                let cost=0, value=0;
                for(let item of this.investments){
                    if(item.amount){
                        cost += parseInt(item.amount);
                    }
                    if(item.currentValue){
                        value +=parseInt(item.currentValue);
                    }
                }
                return (Number(value) / Number(cost)).toFixed(2)
            }
            return null
        },
        chartOptions() {
            const self = this;
            // let d = self.chartData
            let options = {
                maintainAspectRatio: false,
                responsive: true,
                legend:{
                        position: "right",
                        align: "start",
                        labels: {
                        boxWidth: 10,
                        fontSize: 10,
                        fontColor: "#000",
                        fontFamily: "custom-helvetica,roboto"
                        }
                    },
                scale: {
                    ticks: {
                        min: 0,
                        max: this.spvfundSize,
                        
                    }
                }
            };
            return options;
        },
        chartData() {
            let data={
                labels: ['Commited', 'Sent', 'Signed', 'Wired', 'Signed & Wired', 'Co-Signed'],
                datasets: [{
                    label: '# of Votes',
                    data: this.polarChartData,
                    backgroundColor: [
                        '#78DE87',
                        '#E8AC4D',
                        '#9BA7FF',
                        '#EDCACA',
                        '#D5D5D5',
                        '#FFD490'
                    ],
                    borderColor: [
                        '#fff',
                        '#fff',
                        '#fff',
                        '#fff',
                        '#fff',
                        '#fff'
                    ],
                    borderWidth: 1
                }]
            }
            return data;
        },
        managerDetails() {
            return {
                data: this.managerDetailsData,
                layout: "fitColumns",
                tooltips: true,
                layoutColumnsOnNewData: true,
                // index: "_id",
                tooltips: true,
                tooltipsHeader: true,
                placeholder: "No records to view",
                columns: this.managerDetailsTableColumns,
            };
        },
         managerDetailsTableColumns() {
            const self = this;
            return [
                {
                title: "entity name",
                field: "entity_name",
                headerSort: false,
                resizable: true,
                // cellClick:function(e, cell){
                // console.log("data : ", cell.getData())
                // },
                formatter: function (cell, formatterParams) {
                    if(cell.getData().entity_name === "MANAGER TOTALS"){
                        return `<strong>${cell.getData().entity_name}</strong>`
                    }
                    return `${cell.getData().entity_name}`;
                },
                },
                {
                title: "capital commitment",
                field: "capital_commitment",
                headerSort: false,
                resizable: true,
                formatter: function (cell, formatterParams) {
                    if(cell.getData().entity_name === "MANAGER TOTALS"){
                        return `<strong>${cell.getData().capital_commitment}</strong>`
                    }
                    return `${cell.getData().capital_commitment}`;
                },
                tooltip: false,
                },
                {
                title: "ownership%",
                field: "ownership",
                headerSort: false,
                resizable: true,
                formatter: function(cell, formatterParams){
                    if(cell.getData().entity_name === "MANAGER TOTALS"){
                        return `<strong>${cell.getData().ownership}%</strong>`
                    }
                    return `${cell.getData().ownership}%`
                    },
                },
                {
                title: "carry %",
                field: "carry",
                headerSort: false,
                resizable: true,
                formatter: function(cell, formatterParams){
                    if(cell.getData().entity_name === "MANAGER TOTALS"){
                        return `<strong>${cell.getData().carry}%</strong>`
                    }
                    return `${cell.getData().carry}%`
                }
                },
            ];
        },
        syndicateDetails() {
            return {
                data: this.syndicateDetailsData,
                layout: "fitColumns",
                tooltips: true,
                layoutColumnsOnNewData: true,
                // index: "_id",
                tooltips: true,
                tooltipsHeader: true,
                placeholder: "No records to view",
                columns: this.syndicateDetailsTableColumns,
            };
        },
        syndicateDetailsTableColumns() {
            const self = this;
            let handleMenu = function(_cell, a, b) {
                _cell.getElement().addEventListener("click", () => {
                const ctxMenuData = [
                    {
                    title: "Delete",
                    handler: () => {
                        let data = _cell.getData();
                        self.confirmMdlShow=true;
                        self.deleteSyndicateDetailId = data._id;
                    }
                    }
                ];
                self.$root.$emit("contextmenu", { event, ctxMenuData });
                });

                return `
                <i class="fas fa-ellipsis-h" style="color:#0000004D;"></i>
                `;
            };
            var statusEditor = function(cell, onRendered, success, cancel){
                //cell - the cell component for the editable cell
                //onRendered - function to call when the editor has been rendered
                //success - function to call to pass the successfuly updated value to Tabulator
                //cancel - function to call to abort the edit and return to a normal cell

                //create and style input
                var cellValue = cell.getValue()
                let select = document.createElement("select");

                var status = [
                "Commited",
                "Sent",
                "Wired",
                "Signed",
                "Signed & Wired",
                "Co-signed"
                ];

                var options_str = "";

                status.forEach( function(item) {
                options_str += '<option value="' + item + '">' + item + '</option>';
                });

                select.innerHTML = options_str;

                select.style.padding = "4px";
                select.style.width = "100%";
                select.style.boxSizing = "border-box";

                select.value = cellValue;

                onRendered(function(){
                    select.focus();
                    select.style.height = "100%";
                });

                function onChange(){
                    const cellData = cell.getData();
                    api.patch(`/${self.$route.params.account_id}/${self.$route.params.workspace_id}/syndicateDetails/updateStatus`,{
                        syndicateDetailId: cellData._id,
                        status: select.value
                    }).then(res => {
                        success(select.value);
                        self.getsyndicateData()    
                    }).catch(err => {
                        console.log(err);
                    }).finally(() => {
                        cancel();
                    })
                }

                //submit new value on blur or change
                select.addEventListener("blur", async() => {
                    // success(select.value);
                    cancel();
                    });
                select.addEventListener("change", onChange);

                //submit new value on enter
                // input.addEventListener("keydown", function(e){
                //     // if(e.keyCode == 13){
                //     //     onChange();
                //     // }

                //     // if(e.keyCode == 27){
                //     //     cancel();
                //     // }
                //     onChange();
                // });

                return select;
            };
            return [
                {
                title: "entity name",
                field: "entity_name",
                headerSort: false,
                resizable: true,
                // cellClick:function(e, cell){
                // console.log("data : ", cell.getData())
                // },
                formatter: function (cell, formatterParams) {
                    if(cell.getData().entity_name === "INVESTOR TOTALS"){
                        return `<strong>${cell.getData().entity_name}</strong>`
                    }
                    return `${cell.getData().entity_name}`;
                },
                },
                {
                title: "capital commitment",
                field: "capital_commitment",
                headerSort: false,
                resizable: true,
                formatter: function (cell, formatterParams) {
                    if(cell.getData().entity_name === "INVESTOR TOTALS"){
                        return `<strong>$${cell.getData().capital_commitment}</strong>`
                    }
                    return `$${cell.getData().capital_commitment}`;
                },
                tooltip: false,
                },
                {
                title: "ownership %",
                field: "ownership",
                headerSort: false,
                resizable: true,
                formatter: function(cell, formatterParams){
                        if(cell.getData().ownership){
                            if(cell.getData().entity_name === "INVESTOR TOTALS"){
                                return `<strong>${cell.getData().ownership}%</strong>`
                            }
                            return `${cell.getData().ownership}%`   
                        }
                    },
                },
                {
                title: "Profit %",
                field: "profit",
                headerSort: false,
                resizable: true,
                formatter: function(cell, formatterParams){
                    if(cell.getData().profit){
                            if(cell.getData().entity_name === "INVESTOR TOTALS"){
                                return `<strong>${(cell.getData().profit).toFixed(2)}%</strong>`
                            }
                            return `${(cell.getData().profit).toFixed(2)}%`   
                        }
                    }
                },
                {
                title: "Status",
                field: "status",
                headerSort: false,
                resizable: true,
                editor: statusEditor,
                formatter: function(cell, formatterParams){
                        if(cell.getData().status){
                            switch(cell.getData().status){
                                case "Commited":{
                                    return `<span style="background: #78DE87;
                                                        display: inline-block;
                                                        padding: 0 10px 0 10px;
                                                        border-radius: 30px;
                                                        font-size: 14px">
                                                ${cell.getData().status}
                                            </span>`
                                }
                                case "Sent": {
                                    return `<span style="background: #E8AC4D;
                                                        display: inline-block;
                                                        padding: 0 10px 0 10px;
                                                        border-radius: 30px;
                                                        font-size: 14px">
                                                ${cell.getData().status}
                                            </span>`
                                }
                                case "Signed": {
                                    return `<span style="background: #9BA7FF;
                                                        display: inline-block;
                                                        padding: 0 10px 0 10px;
                                                        border-radius: 30px;
                                                        font-size: 14px">
                                                ${cell.getData().status}
                                            </span>`
                                }
                                case "Wired":{
                                    return `<span style="background: #EDCACA;
                                                        display: inline-block;
                                                        padding: 0 10px 0 10px;
                                                        border-radius: 30px;
                                                        font-size: 14px">
                                                ${cell.getData().status}
                                            </span>`
                                }
                                case "Signed & Wired":{
                                    return `<span style="background: #D5D5D5;
                                                        display: inline-block;
                                                        padding: 0 10px 0 10px;
                                                        border-radius: 30px;
                                                        font-size: 14px">
                                                ${cell.getData().status}
                                            </span>`
                                }
                                case "Co-signed": {
                                    return `<span style="background: #FFD490;
                                                        display: inline-block;
                                                        padding: 0 10px 0 10px;
                                                        border-radius: 30px;
                                                        font-size: 14px">
                                                ${cell.getData().status}
                                            </span>`
                                }
                                default:{
                                    return `<span style="background: #78DE87;
                                                 display: inline-block;
                                                 padding: 0 10px 0 10px;
                                                 border-radius: 30px;
                                                 font-size: 14px">
                                        ${cell.getData().status}
                                    </span>`
                                }
                            }
                        }
                    }  
                },
                {
                title: "Fees",
                field: "fees",
                headerSort: false,
                resizable: true,
                formatter: function(cell, formatterParams){
                            if(cell.getData().entity_name === "INVESTOR TOTALS"){
                                // return `<strong>${cell.getData().profit}%</strong>`
                                return
                            }else{
                                return cell.getData().fees ? `${cell.getData().fees}%` : "0%"
                            }
                    }
                },
                {
                title: "",
                field: "",
                sorter: "string",
                width: 20,
                headerSort: false,
                resizable: false,
                formatter: function(_cell, formatterParams) {
                    if (_cell.getData() && _cell.getData().entity_name !== "INVESTOR TOTALS") {
                        return handleMenu(_cell, formatterParams, formatterParams);
                    } else {
                        return "";
                    }
                }
                }
            ];
        },
        fundDetails() {
            return {
                data: this.fundDetailsData,
                layout: "fitColumns",
                tooltips: true,
                layoutColumnsOnNewData: true,
                // index: "_id",
                tooltips: true,
                tooltipsHeader: true,
                placeholder: "No records to view",
                columns: this.fundDetailsTableColumns,
                headerVisible:false,
            };
        },
        fundDetailsTableColumns() {
            const self = this;
            return [
                {
                title: "",
                field: "entity_name",
                headerSort: false,
                resizable: true,
                // cellClick:function(e, cell){
                // console.log("data : ", cell.getData())
                // },
                formatter: function (cell, formatterParams) {
                    return `<strong>${cell.getData().entity_name}</strong>`;
                },
                },
                {
                title: "",
                field: "capital_commitment",
                headerSort: false,
                resizable: true,
                formatter: function (cell, formatterParams) {
                    if(cell.getData().entity_name === "INVESTOR TOTALS"){
                        return `<strong>${cell.getData().capital_commitment}</strong>`
                    }
                    return `<strong>$${cell.getData().capital_commitment}</strong>`
                },
                tooltip: false,
                },
                {
                title: "",
                field: "ownership",
                headerSort: false,
                resizable: true,
                formatter: function(cell, formatterParams){
                        if(cell.getData().ownership){
                            return `<strong>${cell.getData().ownership}%</strong>`   
                        }
                    },
                },
                {
                title: "",
                field: "carry",
                headerSort: false,
                resizable: true,
                formatter: function(cell, formatterParams){
                        if(cell.getData().carry){
                            return `<strong>${cell.getData().carry}%</strong>`   
                        }
                    },
                },
            ];
        },
    },
    watch: {
        managerDetails: {
            handler: function (newData) {
                if (this.managerDetailsTabulator) {
                    this.managerDetailsTabulator.replaceData(this.managerDetails.data);
                }
            },
        },
        syndicateDetails: {
            handler: function (newData) {
                if (this.syndicateDetailsTabulator) {
                    this.syndicateDetailsTabulator.replaceData(this.syndicateDetails.data);
                }
            },
        },
        fundDetails: {
            handler: function (newData) {
                if (this.fundDetailsTabulator) {
                    this.fundDetailsTabulator.replaceData(this.fundDetails.data);
                }
            },
        },
       },
    mounted(){
        setTimeout(() => {
            this.showChart = true;
        },1500)
        let self = this;
        api.get(`/${this.$route.params.account_id}/${this.$route.params.workspace_id}/currentWorkspace`).then((res) => {
            const data = res.data.encrypt.success;
            self.fundDetailsData=[{
                entity_name: "SPV TOTALS",
                capital_commitment: data.targetAllocationAmount,
                ownership: 100,
                carry: 100
            }]

            self.carry = data.carry;

            self.spvfundSize = data.targetAllocationAmount;

            if(data.managementFee.type === "% Fee"){
                self.fees = `${data.managementFee.value}%`
            }else{
                self.fees = `$${data.managementFee.value}`
            }

            const carryRecipients = res.data.encrypt.success.carryRecipients;

            carryRecipients.unshift({
                entity_name: this.user.firstName + " " + this.user.lastName,
                capital_commitment: data.myCommitment,
                ownership: ((data.myCommitment/data.targetAllocationAmount)*100).toFixed(2),
                carry: data.carry
            })

            for(let item of carryRecipients){
                if(!item.capital_commitment){
                    item.capital_commitment = 0;
                }
                if(!item.ownership){
                    item.ownership = 0;
                }
            }

            let total = {
                entity_name: "MANAGER TOTALS",
                capital_commitment: 0,
                ownership: 0,
                carry: 0
            }

            for(let item of carryRecipients){
                total.carry += item.carry;
                total.capital_commitment += item.capital_commitment;
                total.ownership += parseFloat(item.ownership);
            }

            carryRecipients.push(total);
            
            self.managerDetailsData = carryRecipients;
            this.getsyndicateData();
        }).catch(err => {
            console.error("error getting current workspace : ", err);
        })
        if (this.$refs.managerDetailsRefTable && this.managerDetails) {
            this.managerDetailsTabulator = new Tabulator(
                this.$refs.managerDetailsRefTable,
                this.managerDetails
            );
        }
        if(this.$refs.syndicateDetailsRefTable && this.syndicateDetails) {
            this.syndicateDetailsTabulator = new Tabulator(
                this.$refs.syndicateDetailsRefTable,
                this.syndicateDetails
            );
        }
        if(this.$refs.fundDetailsRefTable && this.fundDetails) {
            this.fundDetailsTabulator = new Tabulator(
                this.$refs.fundDetailsRefTable,
                this.fundDetails
            );
        }
    },
    methods:{
        async getsyndicateData(){
            try{
                const data = await api.get(`/${this.$route.params.account_id}/${this.$route.params.workspace_id}/syndicateDetails`);
                const details = data.data.encrypt.success;
                if(!(details.length>0)){
                    this.value.isShow = true;
                }
                const polarChartLabels = ['Commited', 'Sent', 'Signed', 'Wired', 'Signed & Wired', 'Co-signed'];
                const polarChartData = [];
                const customChartData = [];
                let totalTillNow = 0;
                for(let label of polarChartLabels){
                    let labelValue=0;
                    let total = 0;
                    for(let item of details){
                        if(item.status === label){
                            labelValue +=item.capital_commitment;
                            total+=item.capital_commitment;
                            totalTillNow += item.capital_commitment;
                        }
                    }
                    let currentLabel={
                        name: label,
                        total: total,
                        totalTillNow: totalTillNow
                    }
                    customChartData.push(currentLabel);
                    polarChartData.push(labelValue);
                }
                customChartData.push({
                    name: "to allocate",
                    total: parseInt(this.spvfundSize) - totalTillNow,
                    totalTillNow: parseInt(this.spvfundSize)
                })
                this.customChartData = customChartData;
                this.polarChartData = polarChartData;
                // profit;
                let totalProfit = 0;
                let totalCost = 0
                if(this.investments.length > 0){
                    let cost=0, value=0;
                    for(let item of this.investments){
                        if(item.amount){
                            cost += parseInt(item.amount);
                        }
                        if(item.currentValue){
                            value +=parseInt(item.currentValue);
                        }
                    }
                    totalCost = cost;
                    totalProfit = value-cost;
                }
                for(let item of details){
                    if(item.ownership){
                        item.profit = (((item.ownership/100)*totalProfit)/((item.ownership/100)*totalCost))*100;
                        
                    }
                }
                if(details.length>0){
                    const totals = {
                        entity_name: "INVESTOR TOTALS",
                        capital_commitment: 0,
                        ownership: 0,
                    }
                    for(let item of details){
                        totals.capital_commitment += item.capital_commitment;
                        totals.ownership += item.ownership;
                    }
                    totals.ownership = (totals.ownership).toFixed(2);
                    totals.profit = (((totals.ownership/100)*totalProfit)/((totals.ownership/100)*totalCost))*100
                    this.investorTotals = totals.capital_commitment
                    details.push(totals);
                }
                this.syndicateDetailsData = details;                
            }catch(error){
                console.log("Error getting syndicate data : ",error);
            }

        },
        deleteMethod(){
            this.isSaving = true;
            api.delete(`/${this.$route.params.account_id}/${this.$route.params.workspace_id}/syndicateDetails/delete/${this.deleteSyndicateDetailId}`).then((res) => {
                this.getsyndicateData();
            }).catch(err => {
                console.log("error deleting syndicate : ", err);
            }).finally(() => {
                this.isSaving = false;
                this.confirmMdlShow = false;
            })
        },
    }
}
</script>
<style lang="scss" scoped>
    .spvMain{
        padding-top: 15px;
        padding-bottom: 15px;
    }
    .spv-size{
        font-size: 30px;
        span{
            &:first-child{
                margin-right: 20px;
            }
            &:last-child{
                margin-left: 20px;
            }
        }
    }
    .spv-totals{
        font-size: 20px;
        margin-top: 20px;
        div{
            &:first-child{
                margin-right: 10px;
            span{
                    &:first-child{
                        margin-right: 10px;
                    }
                    &:last-child{
                        margin-left: 10px;
                    }
                }
            }
            &:last-child{
                margin-left: 30px;
            span{
                    &:first-child{
                        margin-right: 10px;
                    }
                    &:last-child{
                        margin-left: 10px;
                    }
                }
            }
        }
    }
    .stats{
        div{
            margin: 20px 0 0 0;
            font-size: 20px;
            span{
                &:first-child{
                    margin-right: 20px;
                }
                &:last-child{
                    margin-left: 20px;
                }
            }
        }
    }
    .titleText{
        font-size: 20px;
        margin: 10px 0 10px 0;
    }
    .buttonOutlined{
        background: none;
        color: #5445F399;
        border: 1px solid #5445F399;
    }
    .details{
        span{
            display: inline-block;
            width: 50px;
        }
    }
    .tabulator-header{
        height: 0 !important
    }
    .status{
        padding: 10px;
        display: inline-block;
        border-radius: 10px;
    }
</style>